<template>
  <v-card min-height="580" class="mt-5">
    <v-toolbar flat width="100%" style="padding: 20px">
      <v-toolbar-title class="text-capitalize title"
        >{{ $t("animal.notes") }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn
        @click="showAddEditModal('add')"
        right
        class="ml-5"
        height="50"
        width="241"
        color="primary"
        type="submit"
      >
        {{ $t("addNew") }}
      </v-btn>
      <AddEdit
        @result:success="onResultSaved"
        v-if="showAdd"
        :dialogI="showAdd"
        :item="dataItem"
        @dialog:close="showAdd = false"
      />
    </v-toolbar>

    <div class="mt-7">
      <v-data-table
        class="mt-7"
        :headers="headers"
        :items="showItems"
        :options.sync="tableOptions"
        :items-per-page="itemsPerPage"
        :loading="loading"
        :server-items-length="totalCount"
        show-select
        loading-text="Loading Notes Data..."
        :footer-props="{
          'items-per-page-options': [5, 10, 25],
          'show-first-last-page': true,
          'show-current-page': true,
          'items-per-page-text': 'Notes per page',
        }"
        @update:options="handleOptionsUpdate"
      >
      <template v-slot:top>
          <div class="d-flex mt-5">
              <v-spacer></v-spacer>
              <div class="py-3">
                  {{
                  (tableOptions.page - 1) * tableOptions.itemsPerPage + 1
                  }}
                  -
                  {{
                  tableOptions.page * tableOptions.itemsPerPage -
                  (tableOptions.itemsPerPage - count)
                  }}
                  of {{ totalCount }}
              </div>
              <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page == 1"
                  @click="pageChange(false)">
                  <v-icon dark> mdi-chevron-left </v-icon>
              </v-btn>
              <v-btn class="mx-2" fab small outlined color="primary" :disabled="(tableOptions.page - 1) * tableOptions.itemsPerPage +
                  count >=
                  totalCount
                  " @click="pageChange(true)">
                  <v-icon dark> mdi-chevron-right </v-icon>
              </v-btn>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-toolbar flat width="100%">
            <v-icon dark color="gray" @click="startDelete(item, 'edit')">
              mdi-pencil
            </v-icon>
            <v-icon dark color="red" @click="startDelete(item, 'delete')">
              mdi-delete
            </v-icon>
          </v-toolbar>
        </template>

        <template v-slot:item.updated_date="{ item }">
          {{ formatDate(item.updatedAt, 'YYYY/MM/DD') }}
        </template>

        <template v-slot:footer></template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="showDeleteConfirm"
      transition="dialog-top-transition"
      max-width="500"
      persistent
    >
      <template>
        <v-card rounded="0">
          <v-toolbar color="secondary" class="white--text">
            <v-toolbar-title class="font-weight-bold">
              Warning
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              class="white--text"
              @click="
                showDeleteConfirm = false;
                deleteItem = null;
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text
            class="gray--text py-10"
            style="font-size: 16px"
            v-if="editOrDelete == 'delete'"
          >
            <h2>Are you sure ?</h2>
            <p class="mt-4">Do you really want to delete this record ?</p>
            <p>This process cannot be undone.</p>
            <!--<p>Your previous records might get affected.</p>-->
          </v-card-text>
          <v-card-text
            class="gray--text py-10"
            style="font-size: 16px"
            v-if="editOrDelete == 'edit'"
          >
            <h2>Are you sure ?</h2>
            <p class="mt-4">Do you really want to edit this record ?</p>
            <p>Your previous records might get affected.</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-4 py-5 justify-center">
            <div>
              <v-spacer></v-spacer>
              <v-btn
                @click="
                  showDeleteConfirm = false;
                  deleteItem = null;
                "
                outlined
                class="mr-2 px-5"
                right
                height="44"
                depressed
                color="primary"
              >
                 {{ $t("cancel") }}
              </v-btn>
              <v-btn
                @click="deleteData"
                right
                height="44"
                color="error"
                class="px-5"
                v-if="editOrDelete == 'delete'"
              >
                Delete
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-card>
</template>
<script>
import gql from "graphql-tag";
import AddEdit from "./AddEditNote.vue";
import generalMixin from "@/mixins/GeneralMixin"

export default {
  apollo: {
    notes: {
      query: gql`
        query notes($animalId: Int!, $page: Float, $limit: Float) {
          notes(animalId: $animalId, page: $page, limit: $limit) {
            rows {
              description
              id
              title
              updated_date
              updatedAt
            }
            count
            totalCount
          }
        }
      `,
      variables() {
        return {
          animalId: parseInt(this.$route.params.animal_number),
          page: this.tableOptions.page,
          limit: this.tableOptions.itemsPerPage,        
        };
      },
      result: function ({ data }) {
        if (data) {
          this.dataItem = data.notes[0] || null;
          this.totalCount = data.notes.totalCount;
          this.count = data.notes.count;
          this.loading = false;
        }
      },
      update: data => data.notes.rows,
    },
  },

  created() {
    console.log("breed");
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('lastUploaded'),
          align: "start",
          sortable: true,
          value: "updated_date",
          width: '43%',
        },
        {
          text: this.$t("animal.notes"),
          align: "start",
          sortable: true,
          value: "description",
          width: '43%',
        },
        { 
          text: "", 
          value: "action",
          width: '14%', 
        },
      ],
      dataItem: null,
      deleteItem: null,
      currentData: {},
      showAdd: false,
      showDeleteConfirm: false,
      editOrDelete: "edit",
      loading: false,
      tableOptions: {},
      count: 0,
      totalCount:0,
      itemsPerPage:10,
    };
  },
  mounted() {
    // this.currentData = Object.assign({}, this.notes[0]);
    this.loading = true;
    this.tableOptions.page = 1;
  },
  computed: {
    showItems() {
      return this.notes;
      // let showData = [...this.milkReports];
      //   showData.shift();
      //   return showData;
    },
  },
  components: {
    AddEdit,
  },
  methods: {
    // formatDate(date) {
    //   if (!date) return "";
    //   let createdDate = new Date(date);
    //   createdDate =
    //     createdDate.getDate() +
    //     "/" +
    //     createdDate.getMonth() +
    //     "/" +
    //     createdDate.getFullYear();

    //   return createdDate;
    // },
    async startDelete(item, action) {
      this.editOrDelete = action;
      if (action == "edit") {
        this.dataItem = item;
        this.showAdd = true;
      } else {
        this.showDeleteConfirm = true;
        this.deleteItem = item;
      }
    },

    showAddEditModal(action) {
      if (action == "edit") {
        this.editOrDelete = "edit";
        this.dataItem = this.currentData;
        //this.showDeleteConfirm = true;
      } else {
        this.dataItem = null;
      }
      this.showAdd = true;
    },
    async onResultSaved() {
      this.showAdd = false;
      this.loading = true;
      await this.$apollo.queries.notes.refetch();
    },
    async deleteData() {
      if (!this.deleteItem) {
        alert("No data to delete");
        return;
      }

      let item = this.deleteItem;
      //this.startLoading();
      this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation ($id: Int!) {
              removeNote(id: $id) {
                success
              }
            }
          `,
          // Parameters
          variables: {
            id: Number(item.id),
          },
        })
        .then(async res => {
          this.$notify({
            title: this.$t('noteDeletedSuccessfully'),
            text: res.message,
            type: "success",
            position: "top right",
          });

          this.showDeleteConfirm = false;
          this.deleteItem = null;
          this.loading = true;
          await this.$apollo.queries.notes.refetch();
        })
        .catch(async error => {
          console.log(error);
          this.showDeleteConfirm = false;
          this.deleteItem = null;
        });
      console.log("delete item");
    },

    async pageChange(t) {
      this.loading = true;
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;
      await this.$apollo.queries.notes.refetch();      
    },

    async handleOptionsUpdate(options) {
      if(options.itemsPerPage  && options.itemsPerPage !== this.itemsPerPage){
        this.loading = true;
      }
    }
  },
  mixins: [generalMixin]
};
</script>

<style lang="scss" scoped></style>
